import apiInstance from "../api";
import endPoints from "../endpoints";

export const getEmployeeRetirementDetails = (payload) => {
  return apiInstance().get(
    `${endPoints.vesting.getEmployeeRetirementDetails}/${payload.planId}/${payload.employeeId}`
  );
};
export const getEmployeeVestingDetails = (payload) => {
  return apiInstance().get(
    `${endPoints.vesting.getEmployeeVestingDetails}/${payload.planId}/${payload.employeeId}`
  );
};
export const getEmployeeYOSDetails = (payload) => {
  return apiInstance().get(
    `${endPoints.vesting.getEmployeeYOSDetails}/${payload.planId}/${payload.employeeId}`
  );
};
export const GetEmployeeYOSHistoryDetails = (id) => {
  return apiInstance().get(
    `${endPoints.vesting.GetEmployeeYOSHistoryDetails}/${id}`
  );
};
export const postSaveVestingConfigurationForSource = (payload) => {
  return apiInstance().post(
    `${endPoints.vesting.postSaveVestingConfigurationForSource}`,
    payload
  );
};
export const postEmployeeVestingHistoryDetails = (
  employeeId,
  planId,
  sourceId
) => {
  return apiInstance().get(
    `${endPoints.vesting.postEmployeeVestingHistoryDetails}/${employeeId}/${planId}/${sourceId}`
  );
};
export const runVesting = (payload) => {
  return apiInstance().post(`${endPoints.vesting.runVesting}`, payload);
};
export const getVestingSummaryReport = (payload) => {
  return apiInstance().post(
    `${endPoints.vesting.getVestingSummaryReportDetails}`,
    payload
  );
};
export const getEmployeeVestingReport = (employeeVestingId, planId) => {
  return apiInstance().get(
    `${endPoints.vesting.getEmployeeVestingReportDetails}/${employeeVestingId}/${planId}`
  );
};
